<div>
  @if (!pcnId) {
    <div
      class="row"
      [ngClass]="{ 'bottom-line py-4': pcnId == null }"
      >
      <!-- <app-filter *ngIf="mode !== 'alert' && mode !== 'changeAlert'" class="col-md-9"
    [ngClass]="{ 'col-md-12': app.filterList.open }" [types]="['change']"></app-filter> -->
    @if (!app.filterList.open && app.view) {
      <div class="col-md-12">
        @if (!app.permission.RM.isAnalyst && !app.auth.isRMAdmin) {
          <button
            class="btn btn-sm"
            (click)="app.routing.navigateMail('change')"
            [ngClass]="{ 'btn-default-red': 'change' === mode && pcnId == null }"
            >
            <i class="fa fa-envelope"></i>&nbsp;&nbsp;
            <span>
              {{ app.text.mail.notification }}
            </span>
            @if (app.change.unreadMails > 0) {
              <span
                class="badge"
                [ngClass]="{ selectedBadge: 'change' === mode && pcnId == null }"
                >
                {{ app.change.unreadMails }}
              </span>
            }
          </button>
        }
        @if (app.permission.mail.showNewCasesNotifications) {
          <button
            class="btn btn-sm"
            (click)="app.routing.navigateMail('thread')"
        [ngClass]="{
          'btn-default-red': 'thread' === mode || pcnId != null
        }"
            >
            <i class="far fa-folder-plus"></i>&nbsp;&nbsp;
            <span>
              {{ app.text.mail.pcnInbox }}
            </span>
            @if (app.numberOfUnreadPcns) {
              <span
                class="badge"
          [ngClass]="{
            selectedBadge: 'thread' === mode || pcnId != null
          }"
                >
                {{ app.numberOfUnreadPcns }}
              </span>
            }
          </button>
        }
        @if (app.permission.alert.alertPermission) {
          <button
            class="btn btn-sm"
            type="button"
            (click)="app.routing.navigateMail('alert')"
            [ngClass]="{ 'btn-default-red': 'alert' === mode }"
            >
            <i class="fas fa-exclamation-triangle"></i>&nbsp;&nbsp;
            <span>
              {{ app.text.mail.alert }}
            </span>
            @if (app.numberOfUnreadAlerts) {
              <span
                class="badge"
                [ngClass]="{ selectedBadge: 'alert' === mode }"
                >
                {{ app.numberOfUnreadAlerts }}
              </span>
            }
          </button>
        }
        @if (app.permission.alert.changeAlertPermission) {
          <button
            class="btn btn-sm"
            type="button"
            (click)="app.routing.navigateMail('changeAlert')"
        [ngClass]="{
          'btn-default-red': 'changeAlert' === mode
        }"
            >
            <i class="fab fa-rev"></i>&nbsp;&nbsp;
            <span>
              {{ app.text.mail.change }}
            </span>
            @if (app.numberOfUnreadChangeAlerts) {
              <span
                class="badge"
                [ngClass]="{ selectedBadge: 'changeAlert' === mode }"
                >
                {{ app.numberOfUnreadChangeAlerts }}
              </span>
            }
          </button>
        }
        @if (app.permission.alert.leadTimeAlertsPermission) {
          <button
            class="btn btn-sm"
            type="button"
            (click)="app.routing.navigateMail('leadTimeAlert')"
        [ngClass]="{
          'btn-default-red': 'leadTimeAlert' === mode
        }"
            >
            <i class="fas fa-truck-container"></i>&nbsp;&nbsp;
            <span>
              {{ app.text.alert.leadTimeAlert }}
            </span>
            @if (app.numberOfUnreadLeadTimeAlerts) {
              <span
                class="badge"
          [ngClass]="{
            selectedBadge: 'leadTimeAlert' === mode
          }"
                >
                {{ app.numberOfUnreadLeadTimeAlerts }}
              </span>
            }
          </button>
        }
        @if (app.customer === 'mtu') {
          <button
            class="btn btn-sm"
            type="button"
            (click)="app.routing.navigateMail('inventoryMonitoringAlert')"
        [ngClass]="{
          'btn-default-red': 'inventoryMonitoringAlert' === mode
        }"
            >
            <i class="fa-solid fa-flag-pennant"></i>&nbsp;&nbsp;{{
            app.text.part.inventoryMonitoringAlerts
            }}
            @if (app.numberOfUnreadInvMonAlerts) {
              <span
                class="badge"
          [ngClass]="{
            selectedBadge: 'inventoryMonitoringAlert' === mode
          }"
                >
                {{ app.numberOfUnreadInvMonAlerts }}
              </span>
            }
          </button>
        }
        @if (app.permission.alert.envComplianceAlertsPermission) {
          <button
            class="btn btn-sm"
            type="button"
            (click)="app.routing.navigateMail('envComplianceAlert')"
        [ngClass]="{
          'btn-default-red': 'envComplianceAlert' === mode
        }"
            >
            <i class="fa-brands fa-envira"></i>&nbsp;&nbsp;
            <span>
              {{ app.text.alert.envComplianceAlerts }}
            </span>
            @if (app.numberOfUnreadEnvComplianceAlerts) {
              <span
                class="badge"
          [ngClass]="{
            selectedBadge: 'envComplianceAlert' === mode
          }"
                >
                {{ app.numberOfUnreadEnvComplianceAlerts }}
              </span>
            }
          </button>
        }
        @if (showExport) {
          <button
            class="btn btn-sm btn-clean pull-right"
            (click)="app.alerts.exportData(mode)"
            >
            <i class="fa fa-download"></i>&nbsp;
            {{ app.text.alert.export }}
          </button>
        }
      </div>
    }
    <div class="my-2">
      @if (mode === 'change' && pcnId == null && app.customer != 'oc') {
        <div
          class="descr ps-2 ms-1"
          >
          {{ app.text.mail.notificationDescr }}
        </div>
      }
      @if (mode === 'thread' || pcnId != null) {
        <div class="descr ps-2 ms-1">
          {{ app.text.mail.pcnDescr }} -
          <a [href]="url" target="_blank">{{ url }}</a>
        </div>
      }
      @if (mode === 'alert') {
        <div class="descr ps-2 ms-1">
          {{ app.text.mail.alertsDescr }}
        </div>
      }
      @if (mode === 'changeAlert') {
        <div class="descr ps-2 ms-1">
          {{ app.text.mail.changesDescr }}
        </div>
      }
      @if (mode === 'leadTimeAlert') {
        <div class="descr ps-2 ms-1">
          {{ app.text.mail.leadTimeDescr }}
        </div>
      }
      @if (mode === 'envComplianceAlert') {
        <div class="descr ps-2 ms-1">
          {{ app.text.mail.envComplianceDescr }}
        </div>
      }
    </div>
  </div>
}
@if (!app.filterList.open) {
  <div>
    <router-outlet></router-outlet>
  </div>
}
</div>
